import { defineMessages } from 'react-intl';

const messages = defineMessages({
  pageTitle: {
    id: 'App.ManageGrossRents.PageTitle',
    defaultMessage: 'Manage Gross Rents - {propertyName}',
  },
  header: {
    id: 'App.ManageGrossRents.Header',
    defaultMessage: 'Manage Gross Rents',
  },
  grossRentChanges: {
    id: 'App.ManageGrossRents.Tabs.GrossRentChanges',
    defaultMessage: 'Gross Rent Changes',
  },
  grossRentCertifications: {
    id: 'App.ManageGrossRents.Tabs.GrossRentCertifications',
    defaultMessage: 'Gross Rent Certifications',
  },
  GrossRentLimits: {
    id: 'App.ManageGrossRents.GrossRentLimits',
    defaultMessage: 'Gross Rent Limits',
  },
  grossRentChangesEmptyState: {
    id: 'App.ManageGrossRents.EmptyState.GrossRentChanges',
    defaultMessage: 'No gross rent changes to display.',
  },
  grossRentCertificationsEmptyState: {
    id: 'App.ManageGrossRents.EmptyState.GrossRentCertifications',
    defaultMessage: 'No gross rent certifications to display.',
  },
  noPermissionTooltip: {
    id: 'App.ManageGrossRents.noPermissionTooltip',
    defaultMessage: 'You do not have permission to perform this action.',
  },
});

export default messages;
